import { useEffect, useState, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    TeamsList,
    CurrentTeam,
    sanitize
} from '../../utils'
import Popup from '../../components/Popup'
import { Client, Account, Teams, Functions } from "appwrite";
import { createTeam } from '../../appwrite/methods'
import DashboardMenu from '../../components/DashboardMenu.jsx'
import Skeleton from '@mui/material/Skeleton';
import ThemeOption from '../../components/ThemeOption.jsx'

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import { OutlinedCard } from '../../components/OutlinedCard.jsx';
import LogoLoader from '../../components/LogoLoader';

import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Avatar from '@mui/material/Avatar';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';

import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);
const teams = new Teams(client);
const functions = new Functions(client);


export default function Team() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLoadingScreen(true);
        }, 50);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading && showLoadingScreen) return <LogoLoader />;

    return (<DashboardMenu path="" user={userSession} needsOwner={true} page={userSession && (<div className="page-content">
        <Typography variant="h4" gutterBottom>
            {teamsList[currentTeam]} Team
        </Typography>
        <Grid container spacing={2} sx={{ mt: 3 }}>
            <Grid size={6}>
                <Card>
                    <CardActionArea onClick={() => navigate('/team/members')} sx={{ p: 2 }}>
                        <ManageAccountsOutlinedIcon sx={{ width: '25%', height: '25%', maxWidth: '150px', color: 'primary.main', display: 'flex', m: 'auto', mt: 2, mb: -1}}/>
                        <CardContent>
                            <Typography gutterBottom variant="h2" component="div" sx={{ fontSize: 42 }}>
                                Members
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Add new team members, remove existing members, or change member permissions.
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid size={6}>
                <Card>
                    <CardActionArea onClick={() => navigate('/team/settings')} sx={{ p: 2 }}>
                        <AccountTreeOutlinedIcon sx={{ width: '25%', height: '25%', maxWidth: '150px', color: 'primary.main', display: 'flex', m: 'auto', mt: 2, mb: -1}}/>
                        <CardContent>
                            <Typography gutterBottom variant="h2" component="div" sx={{ fontSize: 42 }}>
                                Permissions
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Manage team roles, permissions and associated resources.
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid size={6}>
                <Card>
                    <CardActionArea onClick={() => navigate('/team/settings')} sx={{ p: 2 }}>
                        <SettingsOutlinedIcon sx={{ width: '25%', height: '25%', maxWidth: '150px', color: 'primary.main', display: 'flex', m: 'auto', mt: 2, mb: -1}}/>
                        <CardContent>
                            <Typography gutterBottom variant="h2" component="div" sx={{ fontSize: 42 }}>
                                Settings
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Team settings such as name and website.
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
        </Grid>
    </div>)} />)
}